import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderResetButton } from 'shared/ui/header-reset-button'

import { PriceFilter } from '../filter-search-screen/components'
import { useFilterState } from '../filter-search-screen/hooks'

import s from './styles.module.scss'

const FilterPriceScreen = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const {
    hasActiveFilters,
    hasChanges,
    onResetFields,
    state,
    filterDataFromRequest,
    onChangePriceFilter,
    onSubmit,
  } = useFilterState()

  const onBack = () => {
    navigate(-1)
  }

  const onReset = () => {
    onResetFields(['rangePrice'])
  }

  return (
    <div className="container">
      <HeaderResetButton
        title={t('price')}
        isCanDisable={hasActiveFilters}
        onBack={onBack}
        onReset={onReset}
      />

      <div className={s.priceFilter}>
        <PriceFilter
          currentPrice={state.rangePrice}
          priceRange={filterDataFromRequest?.priceRange}
          onChange={onChangePriceFilter}
        />
      </div>

      <ButtonContinue
        onClick={onSubmit}
        disabled={!hasChanges}
      >
        <span className="semi-bold-17">{t('apply')}</span>
      </ButtonContinue>
    </div>
  )
}

export default FilterPriceScreen
